import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsWithdrawProps } from "./types";
import { messages } from "./messages";
import {
  GET_INVOICE_SERVICE,
  GET_INVOICE_TYPE,
  WithdrawOperationState,
} from "@letsbit/malcolmlb";
import dayjs from "dayjs";
import { HistoryDownloadReceipt } from "../HistoryDownloadReceipt";
import { DownloadInvoice } from "../DownloadInvoice";
import { RECEIPT_TYPE } from "../HistoryDownloadReceipt/types";

export const HistoryDetailsWithdraw: React.FC<HistoryDetailsWithdrawProps> = ({
  data: withdraw,
}) => {
  const { formatMessage } = useIntl();

  const isArs = withdraw.currency_id === "ars";
  const getStatus = (state?: string) => {
    let stClass = "text-[--color-warning]";
    let st = formatMessage(messages.statusInProgress);

    switch (state) {
      case WithdrawOperationState.SUCCEED:
        stClass = "text-[--color-success]";
        st = formatMessage(messages.statusOk);
        break;
      case WithdrawOperationState.WAITING_AUTHORIZATION:
        st = formatMessage(messages.statusWaitingAuthorization);
        break;
      case WithdrawOperationState.UNAUTHORIZED:
      case WithdrawOperationState.CANCELED:
      case WithdrawOperationState.REJECTED:
      case WithdrawOperationState.FAILED:
        stClass = "text-[--color-error]";
        st = formatMessage(messages.statusFailed);
        break;
    }

    return <span className={stClass}>{st}</span>;
  };
  return (
    <div className="flex flex-col gap-y-6 pdf:p-10">
      <DetailsField
        label={formatMessage(messages.withdraw)}
        value={withdraw.amount + " " + withdraw.ticker_id.toUpperCase()}
      />
      {withdraw.extra_data.receiver_name && (
        <DetailsField
          label={formatMessage(messages.destintary)}
          value={withdraw.extra_data.receiver_name}
        />
      )}
      {withdraw.extra_data.account_number && (
        <DetailsField
          label={formatMessage(messages.accountNumber)}
          value={withdraw.extra_data.account_number}
        />
      )}
      {withdraw.extra_data.bank_legal_name && (
        <DetailsField
          label={formatMessage(messages.entity)}
          value={withdraw.extra_data.bank_legal_name}
        />
      )}
      {withdraw.extra_data.account_type && (
        <DetailsField
          className="capitalize"
          label={formatMessage(messages.accountType)}
          value={withdraw.extra_data.account_type}
        />
      )}
      {isArs && (
        <DetailsField
          label={formatMessage(messages.to)}
          value={withdraw.extra_data.user_full_name ?? ""}
        />
      )}
      {isArs && (
        <DetailsField
          label={formatMessage(messages.cvu)}
          value={withdraw.extra_data.address ?? ""}
        />
      )}
      {isArs && (
        <DetailsField
          label={formatMessage(messages.cuil)}
          value={withdraw.extra_data.nid ?? ""}
        />
      )}
      {withdraw.extra_data.state && (
        <DetailsField
          className="pdf:hidden"
          label={formatMessage(messages.status)}
          value={getStatus(withdraw.extra_data.state)}
        />
      )}
      <DetailsField
        label={formatMessage(messages.date)}
        value={dayjs(withdraw.date).format("DD.MM.YYYY")}
      />
      {isArs && (
        <DetailsField
          label={formatMessage(messages.coelsaId)}
          value={withdraw.extra_data?.txid ?? ""}
        />
      )}
      {!isArs && withdraw.extra_data?.type === "coin" && (
        <DetailsField
          label={formatMessage(messages.txId)}
          value={withdraw.extra_data?.txid ?? ""}
        />
      )}
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={withdraw.tid ?? ""}
        copy
      />
      {(isArs ||
        (withdraw.extra_data?.type === "fiat" &&
          withdraw.extra_data.state === WithdrawOperationState.SUCCEED)) &&
      (withdraw.extra_data?.txid ||
        (withdraw.extra_data?.type === "fiat" &&
          withdraw.extra_data.state === WithdrawOperationState.SUCCEED)) ? (
        <HistoryDownloadReceipt
          receiptType={RECEIPT_TYPE.WITHDRAW}
          movement={withdraw}
        />
      ) : null}
      <DownloadInvoice
        service={GET_INVOICE_SERVICE.PAYMENTS}
        type={GET_INVOICE_TYPE.WITHDRAW}
        external_txid={withdraw.tid ?? ""}
      />
    </div>
  );
};
